export { default as debugPanelTemplate } from './debug-panel.dot';



// WEBPACK FOOTER //
// ./default-modules/ui/debug-panel/templates/index.ts